<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="公司名称"
        v-model.trim="companyName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        size="small"
        v-model="unconfirmed"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="reportType"
        @change="search"
        class="mr10"
      >
        <el-option
          v-for="item in type_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select size="small" v-model="scaleType" @change="search" class="mr10">
        <el-option
          v-for="item in company_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="220px" header-align="center" label="用户名称">
        <template #default="scope">
          <ul>
            <li>订单号：{{ scope.row.orderNo }}</li>
            <li>{{ scope.row.name }}</li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        align="center"
        label="报告类型"
        :formatter="formatType"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="realname"
        label="联系人"
      ></el-table-column>
      <el-table-column
        width="130px"
        prop="username"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column min-width="170" align="center" label="申请时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.applyTime, "yyyy-MM-dd hh:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="scaleType"
        align="center"
        label="企业规模"
        :formatter="formaScale"
      >
      </el-table-column>

      <el-table-column min-width="100px" align="center" label="支付金额">
        <template #default="scope">{{ scope.row.price }}元 </template>
      </el-table-column>
      <el-table-column min-width="120px" align="center" label="支付方式">
        <template #default="scope">
          <ul>
            <li>公司转账</li>
            <li>
              <el-button type="text" @click="payment(scope.row)"
                >查看转账信息</el-button
              >
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column label="确认到账" width="120" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.isPay === 0"
            @click="confirmReceipt(scope.row)"
            >确认到账</el-button
          >
          <el-link
            type="success"
            :underline="false"
            href="javascript:void(0);"
            v-if="scope.row.isPay === 1"
            >已到账</el-link
          >
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="240" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            v-if="scope.row.isPay === 1"
            size="mini"
            @click="archives(scope.row)"
            >查看档案</el-button
          >
          <el-button
            type="success"
            v-if="scope.row.isPay === 1"
            size="mini"
            @click="adopt(scope.row)"
            >通过</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="
              itemData = scope.row;
              refuse_dialog = true;
            "
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 查看档案 -->
    <el-dialog v-model="archives_dialog" width="900px" destroy-on-close>
      <div class="preview-dialog">
        <company></company>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="archives_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 付款信息 -->
    <el-dialog
      v-model="payment_dialog"
      width="900px"
      title="付款信息"
      destroy-on-close
    >
      <div class="payment_dialog-body">
        <el-form size="mini" label-position="right" label-width="90px">
          <el-form-item label="付款账号：">{{
            itemData.payAccount
          }}</el-form-item>
          <el-form-item label="付款银行：">{{
            itemData.paymentBank
          }}</el-form-item>
          <el-form-item label="付款人：">{{ itemData.payer }}</el-form-item>
          <el-form-item label="付款时间：">{{ itemData.payTime }}</el-form-item>
          <el-form-item label="付款凭证："></el-form-item>
          <div v-if="itemData.paymentVoucher">
            <img
              :src="$utils.fileUrl(itemData.paymentVoucher)"
              v-if="
                $utils.fileType(itemData.paymentVoucher) === 'png' ||
                $utils.fileType(itemData.paymentVoucher) === 'jpg'
              "
              alt=""
            />
            <template v-else>
              <embed
                :src="$utils.fileUrl(itemData.paymentVoucher)"
                type="application/pdf"
              />
            </template>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="payment_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog
      v-model="refuse_dialog"
      width="600px"
      title="是否确认驳回申请?"
      destroy-on-close
      @close="close"
    >
      <div class="payment_dialog-body">
        <el-form size="mini" :model="form" :rules="rules" ref="form">
          <el-form-item label="驳回理由：" prop="content">
            <el-input
              type="textarea"
              resize="none"
              rows="6"
              v-model="form.content"
              placeholder="请输入驳回理由"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="danger" size="mini" @click="refuse_dialog = false"
            >关闭</el-button
          >
          <el-button type="primary" size="mini" @click="reject">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      companyName: "",
      unconfirmed: "",
      reportType: "",
      scaleType: "",
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "未确认",
        },
        {
          value: 1,
          label: "已到账",
        },
      ],
      type_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "履约报告",
        },
        {
          value: 2,
          label: "信贷报告",
        },
        {
          value: 3,
          label: "综合报告",
        },
      ],
      company_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "小微企业",
        },
        {
          value: 2,
          label: "中型企业",
        },
        {
          value: 3,
          label: "大型企业",
        },
      ],
      archives_dialog: false,
      payment_dialog: false,
      refuse_dialog: false,
      itemData: {},
      form: {
        content: "",
      },
      rules: {
        content: [
          { required: true, message: "请输入驳回理由", trigger: "blur" },
        ],
      },
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    search() {
      this.getData();
    },
    async getData(page = 1) {
      if (this.companyName.length > 40) {
        this.$message.warning("搜索条件不能超过40个字");
        return;
      }
      try {
        const params = {
          unconfirmed: this.unconfirmed,
          reportType: this.reportType,
          scaleType: this.scaleType,
          name: this.companyName,
          currentPage: page,
          pageSize: 20,
        };
        this.$loading.start();
        const res = await this.$api.xinfuReport.audit.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    formatType(row, column) {
      switch (row.type) {
        case 1:
          return "履约报告";
        case 2:
          return "信贷报告";
        case 3:
          return "综合报告";
      }
    },
    formaScale(row, column) {
      switch (row.scaleType) {
        case 1:
          return "小微企业";
        case 2:
          return "中型企业";
        case 3:
          return "大型企业";
      }
    },
    payment(data) {
      this.itemData = data;
      this.payment_dialog = true;
    },
    archives(data) {
      this.$store.dispatch("setCompanyId", data.companyId);
      this.archives_dialog = true;
    },
    // 确认到账
    confirmReceipt(data) {
      this.$confirm("是否要确认到账?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitConfirmReceipt(data);
        })
        .catch(() => {});
    },
    // 提交确认到账
    async submitConfirmReceipt(data) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            id: data.id,
          };
          const res = await this.$api.xinfuReport.audit.confirmReceipt(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    adopt(data) {
      this.$confirm("是否确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            id: data.id,
            reportStatus: 1,
            content: "",
          };
          this.submitSetData(params);
        })
        .catch(() => {});
    },
    reject() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const params = {
            id: this.itemData.id,
            reportStatus: 2,
            content: this.form.content,
          };
          await this.submitSetData(params);
          this.refuse_dialog = false;
        } else {
          return false;
        }
      });
    },
    // 操作数据
    async submitSetData(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.xinfuReport.audit.setData(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData(this.data.current);
            this.$message.success("操作成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    close() {
      this.form.content = "";
    },
  },
  watch: {
    status: {
      handler(val, ovl) {
        this.getData();
      },
    },
    companyName: {
      handler(val, ovl) {
        this.getData();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;
  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .el-select {
    width: 120px;
  }
}

.end {
  color: $--color-danger;
}

.report {
  cursor: pointer;
}

.preview-dialog {
  img {
    width: 100%;
  }
}

.payment_dialog-body {
  embed {
    width: 100%;
    height: 800px;
  }
  img {
    width: 100%;
  }
}
</style>